export const ALLOWED_TEXT_PATTERN = /^[A-Za-z0-9\s,.'/-]+$/;
export const ALLOWED_NAME_PATTERN = /^[A-Za-z\s,.'-]+$/;
export const PHONE_PATTERN = /^\+?[0-9\s]+$/;

export const TEXT_VALIDATION_MSG =
  'Only letters, numbers, spaces, commas, full stops, hyphens, apostrophes, and forward slashes are allowed';
export const NAME_VALIDATION_MSG =
  'Only letters, spaces, commas, full stops, hyphens, and apostrophes are allowed';
export const PHONE_VALIDATION_MSG =
  'Enter a valid phone number with 7–15 digits (e.g. 07911123456 or +447911123456)';

export function isValidPhone(value: string): boolean {
  if (!value || !PHONE_PATTERN.test(value)) return false;
  const digits = value.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
}

export function normalisePhone(value: string): string {
  return value.replace(/\s+/g, '');
}
